import styles from './FeatureItem.module.scss';
import Image from '@/src/shared/components/Image';
import { Icon, IconProps } from '@/src/shared/components/Icon';
import { clsx } from 'clsx';
import Link from 'next/link';

interface Props {
  icon?: IconProps['name'];
  imageSrc?: string;
  title: string;
  description: string;
  href: string;
}

export function FeatureItem({
  imageSrc,
  title,
  description,
  icon,
  href,
}: Props) {
  return (
    <Link
      href={href}
      target="_blank"
      className={clsx(styles.card, {
        [styles.disabled]: !Boolean(href),
      })}
    >
      <div className={styles.titleWrapper}>
        <div
          className={clsx(styles.iconWrapper, {
            [styles.image]: icon == null,
          })}
        >
          {icon != null ? (
            <Icon name={icon} />
          ) : (
            <Image src={imageSrc} alt={title} fill />
          )}
        </div>
        <h6 className={styles.title}>
          {title} <Icon name="chevron-right" className={styles.arrowIcon} />
        </h6>
      </div>
      <p className={styles.description}>{description}</p>
    </Link>
  );
}
